import { Switch } from '@lib/components'
import type React from 'react'

import css from './PreviewSwitcher.module.scss'

type Props = {
  checked: boolean
  onChange: (value: boolean) => void
}

export const PreviewSwitcher: React.FC<Props> = ({ checked, onChange }) => {
  return (
    <div className={css.container}>
      <div className={css.labelWrap}>
        <span className={css.label}>Page preview</span>
        <span className={css.description}>
          Display page layout, block titles and empty blocks.
        </span>
      </div>

      <Switch
        mode="thin"
        checked={checked}
        classes={{ container: css.switcher }}
        onChange={onChange}
      />
    </div>
  )
}
